import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { BookrawAppModule } from 'bookraw/app.module';
import { environment } from 'env/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(BookrawAppModule)
  .catch(err => console.error(err));
